var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-add mt30"},[_c('el-form-item',{attrs:{"label":"供应商申请协议  "}},[_c('el-input',{staticClass:"max-w460",attrs:{"type":"textarea","rows":"5"},model:{value:(_vm.form.license),callback:function ($$v) {_vm.$set(_vm.form, "license", $$v)},expression:"form.license"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f455da5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/setting/part/License.vue
// module id = null
// module chunks = 